import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import AccordionSummary from '@mui/material/AccordionSummary';

export const SpedNotesStudentsAccordionSummary = styled(AccordionSummary)(
  ({ theme }) => ({
    minHeight: 48,
    '&.Mui-expanded': {
      minHeight: 48,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      '&.Mui-expanded': {
        margin: 0,
      },
    },
  }),
);

export const SpedPaper = styled(Paper)`
  padding: 24px;
  background-color: #f8f9fa;
`;

export const SpedGridForm = styled(Grid)`
  padding: 0px 30px;
`;

export const BulkSignOffButtonGrid = styled(Grid)`
  display: flex;
  justify-content: flex-end;
`;

export const BulkSignOffCheckbox = styled(Checkbox)`
  margin-left: 12px;
`;
